import Career from "@/components/Career";
import React from "react";

export default function Careers(): JSX.Element {
  return <Career />;
}
